import PropTypes from 'prop-types';
import styles from './FJAppLeft.module.less';
import classNames from 'classnames';

const FJAppLeft = props => {
    const { children, style, className } = props;
    return (
        <div className={classNames(styles.app_left, className)} style={style && { ...style }}>
            {children}
        </div>
    );
};

FJAppLeft.propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    className: PropTypes.string,
};

export default FJAppLeft;
